import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react'
import { Form, Input, Button, Col, Row, Modal, Table, Tag, Select, Radio, Popover, Popconfirm, message, } from 'antd'
import { useSelector, useDispatch, } from 'react-redux'
import { InfoCircleTwoTone } from "@ant-design/icons"
import { Link, useHistory, useLocation } from "react-router-dom"
import './index.css'
import StepOne from './component/step/stepOne'
import StepTwo from './component/step/stepTwo'
import StepThree from './component/step/stepThree'
import Achievement from './component/step/Achievement'
// import StepFour from './component/step/stepFour'
import StepFourNew from './component/step/stepFourNew'
import Footer from './component/footer'
import StepFive from './component/step/stepFive'
import Lenders from '../Management/Lenders'
import Feature from './component/step/features'
import UpgradeToBusinessModal from '../Management/UpgradeToBusinessModal'
export default function ManagerSetUp(props) {
    const { open, step, showAchievement, showLenders, showPricing, selectLenders } = useSelector(state => {


        return state.manager
    })
    const subscription = useSelector(state => state.subscriptionReducer.currentInfo)
    const [isFourText, setFourText] = useState(false)
    const [isUpgradePlanModalOpen, setIsUpgradePlanModalOpen] = useState(false)
    const history = useHistory()
    const dispatch = useDispatch()
    const stepComponent = [
        <StepOne></StepOne>,
        <StepTwo></StepTwo>,
        <StepThree></StepThree>,
        <StepFourNew></StepFourNew>,
        <StepFive></StepFive>
    ]
    const hasRun = useRef(false);

    useEffect(() => {
        if (hasRun.current) return;
        hasRun.current = true;
    }, [])
    useEffect(() => {
        if (open && window.location.pathname !== '/app/welcome') {
            history.push('/app/welcome')
        } else {
           

        }
        // 
    }, [open])
    const sendMsgToSlack = () => {

        let token = sessionStorage.getItem("ZeitroA")

        fetch("/los/addlenderrequest", {
            method: "GET",
            headers: {
                Authorization: "Bearer " + token,
                Cache: "no-cache",
            },
        }).then((response) => {
            if (response.status !== 200) {
                console.log(
                    "/los/addlenderrequest: Looks like there was a problem. Status Code: " +
                    response.status
                )
                return
            }
        })
    }
    return (
        <>
            {
                <Modal
                    maskClosable={false}
                    centered
                    wrapClassName={showLenders || showPricing ? 'modal_warp' : ''}
                    classNames={{
                        content: showLenders || showPricing ? 'modal_content' : 'onboarding',
                    }} open={open} width={showLenders ? '80%' : showPricing ? '80%' : '993px'}
                    footer={selectLenders ? <Footer isFourText={isFourText} ></Footer> : <div>
                        <div className='lendersLine' style={{ bottom: 83 }}></div>
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                {subscription.plan === 'business' || subscription.plan === 'enterprise' || subscription.plan === 'individual' ? (
                                    <Popconfirm
                                        id="addLenderRequest"
                                        title="Would you like to send a request to add lenders to the Zeitro team?"
                                        description="After submitting your request, Zeitro will reach out to you with instructions on how to add additional lenders to the system. We may require your assistance in obtaining the necessary information for these lenders."
                                        onConfirm={() => {
                                            sendMsgToSlack()
                                            message.success("Your request has been sent, and the Zeitro team will contact you soon.")
                                        }}
                                        onCancel={() => { }}
                                        okText="Send request"
                                        placement="top"
                                        overlayStyle={{ width: 400 }}
                                        cancelText="Cancel"
                                        icon={<InfoCircleTwoTone />}
                                    ><a variant="link" style={{ textDecoration: "underline", color: "#325CEB", fontWeight: 500, fontSize: 16 }}>Can't find your lender? </a></Popconfirm>
                                ) : (
                                    <Popconfirm
                                        id="addLenderRequest"
                                        title="This feature is available on the Individual Plan. To add lenders that aren't currently in our system, please upgrade to the Individual Plan."
                                        onConfirm={() => {
                                            // setIsUpgradePlanModalOpen(true)
                                            dispatch({ type: "OPEN", data: false })
                                            dispatch({ type: "SELECT_LENDERS", data: true })
                                            sessionStorage.setItem('path', 'Pricing')
                                            window.open('/app/management', '_self')
                                        }}
                                        onCancel={() => { }}
                                        okText="Upgrade now"
                                        placement="top"
                                        overlayStyle={{ width: 400 }}
                                        cancelText="Cancel"
                                        icon={<InfoCircleTwoTone />}
                                    ><a variant="link" style={{ textDecoration: "underline", color: "#325CEB", fontWeight: 500, fontSize: 16 }}>Can't find your lender? </a></Popconfirm>
                                )}
                            </div>

                            <Button className="addLenderButton" onClick={() => {
                                const Submit = document.querySelector('#addLenderButton')

                                Submit.click()

                            }}>
                                Add
                            </Button>

                        </div>
                    </div>
                    } onCancel={() => {
                        // 清除 URL 中的参数
                        history.replace({
                            pathname: history.location.pathname,
                            search: ''
                        });
                        
                        if (step === 0 && showLenders) {
                            dispatch({ type: "SHOW_LENDERS", data: false })
                            dispatch({ type: "SELECT_LENDERS", data: true })
                            return
                        }
                        dispatch({ type: "OPEN", data: false })
                        dispatch({ type: "SELECT_LENDERS", data: true })
                      
                    }}>
                    <div style={{
                        height: (showLenders || showPricing || step == 1) ? '100%' : showAchievement ? 530 : 540,
                        overflowY: 'auto',
                        overflowX: 'hidden'
                    }}>
                        {
                            showPricing ? <Feature></Feature> : <>
                                {
                                    showAchievement ?
                                        <Achievement ></Achievement>
                                        : <>
                                            {
                                                showLenders ? <div className='Achievement'><Lenders isManager={true} ></Lenders></div> : stepComponent[step]
                                            }
                                        </>
                                }
                            </>
                        }
                    </div>


                </Modal>}

                <UpgradeToBusinessModal
                    isOpen={isUpgradePlanModalOpen}
                    onClose={() => {
                        setIsUpgradePlanModalOpen(false)
                    }}
                    onUpgrade={() => {
                        setIsUpgradePlanModalOpen(false)
                        dispatch({ type: "OPEN", data: false })
                        dispatch({ type: "SELECT_LENDERS", data: true })
                        sessionStorage.setItem('path', 'Pricing')
                        window.open('/app/management', '_self')
                    }}
                />

        </>


    )
}